var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path, _rect14, _path2, _rect15, _path3, _rect16, _path4, _rect17, _path5, _rect18, _path6, _rect19, _path7, _rect20, _path8, _rect21, _path9, _rect22, _path10, _rect23, _path11, _rect24, _path12, _rect25, _path13, _rect26, _path14, _rect27, _path15, _rect28, _path16, _rect29, _path17, _rect30, _path18, _rect31, _path19, _rect32, _path20, _rect33, _path21, _rect34, _path22, _rect35, _path23, _rect36, _path24, _rect37, _path25, _rect38, _path26, _rect39, _path27, _rect40, _path28, _rect41, _path29, _rect42, _path30, _rect43, _path31, _rect44, _path32, _rect45, _path33, _rect46, _path34, _rect47, _path35, _rect48, _path36, _rect49, _path37, _rect50, _path38, _rect51, _path39, _rect52, _path40, _rect53, _path41, _rect54, _path42, _rect55, _path43, _rect56, _path44, _rect57, _path45, _rect58, _path46, _rect59, _path47, _rect60, _path48, _rect61, _path49, _rect62, _path50, _rect63, _path51, _rect64, _path52, _rect65, _path53, _rect66, _path54, _rect67, _path55, _rect68, _path56, _rect69, _path57, _rect70, _path58, _rect71, _path59, _rect72, _path60, _rect73, _path61, _rect74, _path62, _rect75, _path63, _rect76, _path64, _rect77, _path65, _rect78, _path66, _rect79, _path67, _rect80, _path68, _rect81, _path69, _rect82, _path70, _rect83, _path71, _rect84, _path72, _rect85, _path73, _rect86, _path74, _rect87, _path75, _rect88, _path76, _rect89, _path77, _rect90, _path78, _rect91, _path79, _rect92, _path80, _rect93, _path81, _rect94, _path82, _rect95, _path83, _rect96, _path84, _rect97, _path85, _rect98, _path86, _rect99, _path87, _rect100, _path88, _rect101, _path89, _rect102, _path90, _rect103, _path91, _rect104, _path92, _rect105, _path93, _rect106, _path94, _rect107, _path95, _rect108, _path96, _rect109, _path97, _rect110, _path98, _rect111, _path99, _rect112, _path100, _rect113, _path101, _rect114, _path102, _rect115, _path103, _rect116, _path104, _rect117, _path105;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleMetricTableSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 379,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 451,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 523,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 739,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 811,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 883,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 955,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1027,
    y: 12,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8FA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17,
    width: 40,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M200.5 38v40"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 53,
    width: 81,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M.5 38v40M.5 78v40M.5 134v40M.5 174v40M.5 214v40M.5 254v40M.5 294v40M.5 334v40M0 77.5h200M0 37.5h201M210 77.5h870M209 37.5h871"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M281.5 38.5v39"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M353.5 38.5v39"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M425.5 38v40"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 443,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M497.5 38v40"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M569.5 38v40"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 587,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M641.5 38v40"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 659,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M713.5 38v40"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 731,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M785.5 38v40"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 803,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M857.5 38v40"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 875,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M929.5 38v40"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 947,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1001.5 38v40"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1019,
    y: 53,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1079.5 38v40M200.5 78v40"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 93,
    width: 81,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M0 117.5h200M209 117.5h871"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M281.5 78v40"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M353.5 78v40"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M425.5 78v40"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 443,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M497.5 78v40"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M569.5 78v40"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 587,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M641.5 78v40"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 659,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M713.5 78v40"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 731,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M785.5 78v40"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 803,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M857.5 78v40"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 875,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M929.5 78v40"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 947,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1001.5 78v40"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1019,
    y: 93,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1079.5 78v40"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 149,
    width: 81,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M200.5 134v40M0 173.5h201M0 134.5h201M209 173.5h870M209 134.5h870"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M282.5 134v40"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M354.5 134v40"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M426.5 134v40"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M498.5 134v40"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M570.5 134v40"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M642.5 134v40"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M714.5 134v40"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M786.5 134v40"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 804,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M858.5 134v40"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M930.5 134v40"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 948,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1002.5 134v40"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 149,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1079.5 134v40"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 189,
    width: 81,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M200.5 174v40M0 213.5h201M209 213.5h870"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M282.5 174v40"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M354.5 174v40"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M426.5 174v40"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M498.5 174v40"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M570.5 174v40"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M642.5 174v40"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M714.5 174v40"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M786.5 174v40"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 804,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M858.5 174v40"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M930.5 174v40"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 948,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1002.5 174v40"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 189,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1079.5 174v40"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 229,
    width: 81,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M200.5 214v40M0 253.5h201M209 253.5h870"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M282.5 214v40"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M354.5 214v40"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M426.5 214v40"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M498.5 214v40"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M570.5 214v40"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M642.5 214v40"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M714.5 214v40"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M786.5 214v40"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 804,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M858.5 214v40"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M930.5 214v40"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 948,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1002.5 214v40"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 229,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1079.5 214v40"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 269,
    width: 81,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M200.5 254v40M0 293.5h201M209 293.5h870"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M282.5 254v40"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M354.5 254v40"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M426.5 254v40"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M498.5 254v40"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M570.5 254v40"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M642.5 254v40"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M714.5 254v40"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M786.5 254v40"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 804,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M858.5 254v40"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M930.5 254v40"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 948,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1002.5 254v40"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 269,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1079.5 254v40"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 309,
    width: 81,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M200.5 294v40M0 333.5h201M209 333.5h870"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M282.5 294v40"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M354.5 294v40"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M426.5 294v40"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M498.5 294v40"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M570.5 294v40"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M642.5 294v40"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M714.5 294v40"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M786.5 294v40"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 804,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M858.5 294v40"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M930.5 294v40"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 948,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1002.5 294v40"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 309,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1079.5 294v40"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 349,
    width: 81,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M200.5 334v40M209.5 38v40M209.5 78v40M209.5 134v40M209.5 174v40M209.5 214v40M209.5 254v40M209.5 294v40M209.5 334v40M0 373.5h201M209 373.5h870"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M282.5 334v40"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M354.5 334v40"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M426.5 334v40"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M498.5 334v40"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M570.5 334v40"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M642.5 334v40"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M714.5 334v40"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 732,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M786.5 334v40"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 804,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M858.5 334v40"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#F5F8FA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M930.5 334v40"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 948,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1002.5 334v40"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 349,
    width: 36,
    height: 10,
    rx: 5,
    fill: "#E6EAED"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6ECF0",
    d: "M1079.5 334v40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleMetricTableSkeleton);
export default __webpack_public_path__ + "static/media/MultipleMetricTableSkeleton.4c32b2742da1c90b91be58f479269d64.svg";
export { ForwardRef as ReactComponent };